import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1237.000000 1280.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" >
				<path d="M3869 8736 c-56 -32 -59 -53 -59 -414 l0 -331 42 -48 c89 -103 193
-213 201 -213 9 0 120 116 125 132 2 5 -4 17 -15 26 -10 9 -49 50 -86 91 l-67
73 0 249 0 249 163 -2 162 -3 5 -212 c5 -200 6 -214 26 -234 l22 -21 39 43
c22 24 56 63 77 86 l37 41 -1 204 c-2 218 -8 254 -53 276 -13 6 -136 13 -307
17 -241 4 -289 3 -311 -9z"/>
<path d="M5175 8688 c-27 -29 -78 -85 -114 -123 -36 -39 -115 -125 -176 -190
-114 -124 -218 -236 -316 -340 -31 -33 -87 -94 -126 -135 -38 -41 -93 -101
-123 -133 l-53 -58 39 -42 c21 -23 41 -44 44 -47 3 -3 29 -32 59 -65 30 -33
80 -87 111 -120 31 -33 159 -172 285 -310 126 -137 271 -296 323 -352 l95
-103 366 0 367 0 32 28 c18 15 35 41 38 58 7 34 -1 44 -170 228 -50 54 -95
104 -101 110 -5 6 -62 67 -125 136 -63 69 -133 145 -156 170 -22 25 -94 102
-158 172 -65 70 -116 132 -114 137 1 6 140 157 308 337 168 180 328 352 355
382 28 30 76 82 108 116 66 69 75 92 53 135 -32 60 -38 61 -439 61 l-364 0
-48 -52z m513 -157 c-1 -5 -21 -29 -43 -53 -235 -254 -580 -624 -621 -668 -29
-30 -62 -66 -73 -81 l-19 -25 41 -45 c23 -24 89 -96 147 -159 58 -63 130 -142
161 -175 30 -33 80 -87 110 -120 30 -33 61 -67 69 -75 71 -71 220 -240 220
-249 0 -8 -56 -11 -188 -11 l-188 0 -60 63 c-32 34 -106 114 -164 177 -58 63
-159 174 -225 245 -266 289 -310 338 -313 346 -5 13 15 38 153 186 72 76 157
167 190 203 33 36 94 101 135 145 188 199 219 232 251 268 l34 37 193 0 c114
0 192 -4 190 -9z"/>
<path d="M6298 8688 c-59 -65 -120 -132 -207 -223 -36 -39 -93 -100 -126 -135
-68 -75 -191 -207 -274 -295 -304 -324 -303 -323 -289 -343 11 -17 294 -327
507 -557 41 -44 95 -102 120 -130 211 -230 259 -283 281 -307 l25 -28 365 1
c201 1 379 1 395 2 17 0 64 -8 105 -18 57 -14 115 -18 245 -18 151 1 181 4
270 27 250 65 412 203 486 413 30 85 37 233 15 323 -37 150 -85 223 -203 305
-126 88 -243 134 -521 206 -208 54 -287 85 -334 132 -88 91 -50 218 80 267 73
28 192 37 263 20 117 -28 212 -103 225 -179 12 -71 6 -68 117 -75 56 -3 156
-6 222 -7 l120 -1 -1 64 c-6 236 -153 440 -384 531 -131 52 -199 62 -405 61
-104 0 -208 -5 -230 -11 -32 -7 -45 -6 -65 6 -20 14 -78 16 -390 19 l-365 3
-47 -53z m502 -154 c0 -8 -59 -83 -111 -139 -66 -72 -172 -186 -259 -279 -41
-44 -100 -108 -130 -141 -31 -33 -99 -107 -153 -163 -63 -68 -94 -108 -89
-117 6 -10 135 -153 217 -239 11 -12 67 -73 125 -136 104 -114 198 -216 233
-252 10 -11 32 -43 49 -71 17 -29 43 -68 59 -88 16 -20 29 -40 29 -43 0 -3
-77 -6 -171 -6 l-172 0 -46 48 c-26 26 -143 153 -260 282 -118 129 -259 284
-315 344 -132 142 -146 159 -146 172 0 12 28 44 128 149 37 39 94 99 127 135
154 167 326 352 391 420 39 41 82 87 94 103 l24 27 188 0 c103 0 188 -3 188
-6z m-132 -531 c19 -92 56 -159 126 -229 105 -105 240 -163 593 -254 298 -77
379 -132 376 -256 -2 -88 -44 -142 -148 -191 -56 -26 -69 -28 -185 -28 -116 0
-129 2 -185 28 -32 15 -74 39 -91 52 -40 31 -84 117 -84 167 0 48 5 47 -238
50 l-192 3 -78 85 c-42 46 -114 124 -159 172 -46 49 -83 94 -83 101 1 6 33 46
71 87 39 41 112 119 161 173 50 53 93 97 97 97 4 0 12 -26 19 -57z"/>
<path d="M3945 7584 c-54 -58 -108 -117 -118 -131 -18 -22 -20 -48 -25 -348
-5 -349 -3 -367 46 -405 23 -19 41 -20 321 -20 313 1 310 0 344 50 15 21 17
53 17 237 l0 212 -67 75 c-38 42 -73 76 -79 76 -6 0 -18 -8 -27 -18 -14 -15
-17 -50 -19 -228 l-3 -209 -165 0 -165 0 -3 243 -2 243 62 67 c34 37 76 82 92
99 l29 33 -59 62 c-32 35 -64 64 -70 66 -5 1 -55 -45 -109 -104z"/>
<path d="M7049 6350 c-82 -15 -149 -82 -149 -148 0 -68 59 -119 181 -157 77
-24 102 -45 102 -84 0 -44 -23 -63 -83 -69 -46 -4 -54 -2 -81 24 -16 15 -29
34 -29 41 0 9 -15 13 -50 13 -55 0 -61 -9 -36 -58 33 -63 109 -103 195 -101
62 1 105 18 146 58 88 86 40 201 -102 245 -118 37 -154 67 -138 116 19 60 142
55 165 -6 8 -21 16 -24 55 -24 40 0 45 2 45 23 0 80 -115 146 -221 127z"/>
<path d="M3890 6085 l0 -265 50 0 50 0 0 45 c0 35 6 52 25 70 31 32 91 34 129
4 22 -17 26 -28 26 -70 l0 -49 50 0 50 0 0 56 c0 35 -6 67 -17 85 -15 25 -68
59 -116 73 -16 5 -8 18 47 81 36 42 66 80 66 85 0 6 -22 10 -49 10 l-49 0 -78
-96 -79 -95 -3 165 -2 166 -50 0 -50 0 0 -265z"/>
<path d="M4310 6085 l0 -265 49 0 48 0 5 52 c4 38 12 57 28 70 30 25 91 23
124 -3 22 -17 26 -28 26 -70 l0 -49 55 0 54 0 -4 54 c-6 89 -43 138 -115 153
-17 3 -30 9 -30 14 0 5 29 43 65 84 36 41 65 77 65 80 0 3 -23 5 -50 5 -57 0
-59 -2 -153 -117 -28 -35 -54 -63 -59 -63 -4 0 -8 72 -8 160 l0 160 -50 0 -50
0 0 -265z"/>
<path d="M5225 6339 c-3 -8 -4 -127 -3 -264 l3 -250 110 0 c99 1 115 3 161 27
124 65 180 189 139 309 -39 114 -139 175 -303 185 -83 6 -102 4 -107 -7z m219
-104 c124 -59 127 -241 5 -302 -24 -12 -60 -23 -79 -25 l-35 -3 -3 179 -2 179
38 -6 c22 -2 56 -13 76 -22z"/>
<path d="M7740 6084 l0 -266 133 4 c123 3 135 5 179 31 74 43 93 78 93 168 0
68 -3 79 -29 113 -52 69 -153 93 -253 61 -23 -7 -23 -6 -23 74 l0 81 -50 0
-50 0 0 -266z m270 27 c61 -43 64 -128 5 -180 -25 -22 -47 -30 -94 -36 -33 -4
-65 -4 -70 0 -9 5 -17 215 -8 215 1 0 20 7 42 14 46 16 89 12 125 -13z"/>
<path d="M6155 6305 c-5 -2 -22 -6 -37 -9 l-28 -6 0 -183 c0 -153 3 -188 18
-217 23 -47 72 -70 150 -70 l62 0 0 35 c0 29 -4 35 -22 36 -101 3 -110 14
-106 139 l3 95 63 3 62 3 0 40 0 41 -62 -4 -63 -3 -3 53 c-3 50 -8 57 -37 47z"/>
<path d="M4800 6200 c-47 -11 -90 -61 -90 -104 0 -50 32 -83 98 -102 108 -31
127 -40 131 -59 6 -33 -26 -45 -126 -45 l-93 0 0 -35 0 -35 115 0 c130 0 165
11 190 60 36 70 1 137 -86 160 -125 34 -124 34 -124 60 0 25 1 25 100 30 l100
5 0 35 0 35 -90 2 c-49 1 -106 -2 -125 -7z"/>
<path d="M5775 6195 c-39 -18 -59 -35 -73 -62 -19 -35 -14 -43 29 -43 29 0 50
7 71 25 53 45 134 24 139 -35 3 -47 1 -52 -20 -40 -33 17 -152 12 -191 -8 -68
-36 -86 -117 -37 -170 46 -51 149 -68 222 -38 19 8 35 11 35 5 0 -5 20 -9 45
-9 l45 0 0 147 c0 142 -1 147 -26 181 -15 19 -42 40 -60 48 -43 18 -140 17
-179 -1z m130 -209 c30 -13 35 -20 35 -48 0 -45 -44 -73 -102 -65 -82 11 -105
76 -38 109 43 22 60 22 105 4z"/>
<path d="M6440 6194 c-39 -17 -79 -60 -80 -86 0 -30 79 -24 109 7 17 18 34 25
62 25 51 0 79 -27 79 -76 0 -31 -3 -35 -17 -28 -38 17 -150 16 -188 -2 -100
-47 -93 -166 12 -210 44 -19 127 -18 166 2 21 12 32 13 35 5 2 -6 24 -11 48
-11 l44 0 0 138 c0 163 -11 194 -80 230 -52 26 -137 29 -190 6z m135 -208 c31
-13 35 -19 35 -50 0 -29 -5 -38 -30 -51 -62 -32 -150 -7 -150 43 0 35 10 49
40 61 36 14 66 13 105 -3z"/>
<path d="M7320 6076 c0 -169 16 -211 95 -247 84 -39 205 -13 245 53 17 29 20
50 20 176 l0 142 -44 0 -44 0 -4 -136 c-3 -129 -4 -137 -27 -155 -36 -29 -94
-25 -120 7 -19 24 -21 40 -21 155 l0 129 -50 0 -50 0 0 -124z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
